<template>
    <v-flex>
      <v-row>
        <v-col cols="12" md="6" lg="6">
          <v-skeleton-loader
            type="card-heading, image"
            min-height="160"
          >
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="6" lg="6">
          <v-skeleton-loader
            type="card-heading, image"
            min-height="160"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row>

    </v-flex>
</template>

<script>
    export default {
        name: "profileLinUpdatesBoiler"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Boilerpalettes/profileLinUpdatesBoiler.vue